import React from "react"
import "./style.scss"
import { Button, useTheme, makeStyles } from "@material-ui/core"
import { navigate } from "gatsby"

const useStyles = makeStyles(theme => ({
  bookdemoBtn: {
    borderRadius: '6.4225px',
    background: 'linear-gradient(108deg, #00507f 0%, #15b09a 100%)',
    textTransform: 'none',
    height: 'fit-content',
    width: '165px',
    color: '#FFFFFF',
    marginTop: '36px',
    [theme.breakpoints.between(450, 576)]: {
      marginTop: '35px',
    },
    [theme.breakpoints.up(576)]: {
      display: 'none'
    },
    [theme.breakpoints.down(320)]: {
      marginTop: '5px',
      marginBottom: '8px',
    },
  },
  withBtn: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down(320)]: {
      flexDirection: 'column',
    },
  },
}))

const MeetWersel = ({ title, platformText }) => {
  const classes = useStyles()
  const theme = useTheme()
  return (
    <div className="wersel_overview">
      <div className={classes.withBtn}>
      <h1 className="meet_wersel">Wersel <span className="title">WorkDesk</span></h1>
      <Button className={classes.bookdemoBtn} variant="contained" size='small' onClick={()=> navigate(`https://wersel.world/learn`)}> Course Registration </Button>
      </div>
      <p className="sub-text"><span className="subTitle">{title} </span>{platformText}</p>
      <div className="videoContainer">
        {/* <iframe
          className="video_file"
          src="https://www.youtube.com/embed/Muipn2LaAkA?autoplay=1&mute=1&playlist=Muipn2LaAkA&loop=1"
          title="Wersel Workdesk Overview - Intelligent Data Driven Decision Making Platform"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe> */}
        <iframe
          className="video_file"
          src="https://player.vimeo.com/video/652798265?h=6b58335b49&autoplay=1&loop=1"
          frameborder="0"
          allow="fullscreen; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  )
}

export default MeetWersel
